import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "b-left-bar-menu" }
const _hoisted_2 = { class: "b-left-bar-menu__inner" }
const _hoisted_3 = { class: "b-left-bar-menu__title h-text-center" }
const _hoisted_4 = {
  key: 0,
  class: "b-left-bar-menu__list"
}
const _hoisted_5 = { class: "b-left-bar-menu__item__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('MENU')), 1),
      (_ctx.showMenuOptions && _ctx.showMenuOptions.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showMenuOptions, (item) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: item.icon,
                to: item.link,
                class: "b-left-bar-menu__item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_FwIcon, {
                    class: "b-left-bar-menu__item__icon",
                    icon: item.icon,
                    size: "25",
                    color: "#fff"
                  }, null, 8, ["icon"]),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(item.text), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}